import { createAction } from 'redux-actions';

export const getEntitlements = createAction('GET_ENTITLEMENTS');
export const getEntitlementsSuccess = createAction('GET_ENTITLEMENTS_SUCCESS');
export const getEntitlementsFailure = createAction('GET_ENTITLEMENTS_FAILURE');
//////////////////////////////////////////////////////////////////////////////////
export const setEntitlement = createAction('SET_ENTITLEMENT');
/////////
